import { ChevronRightIcon, GlowingTrophy } from '@/common/assets';
import RoundButton from '../RoundButton/RoundButton';
import BracketCard from '../BracketCard/BracketCard';
import type { MatchGroupProps } from './Knockout.types';
import { MatchGroupPrevious } from './MatchGroupPrevious';

export default function MatchGroup(props: MatchGroupProps) {
  const {
    firstMatch,
    secondMatch,
    thirdPlaceMatch,
    isFinal,
    isPreviousButtonVisible,
    isNextButtonVisible,
    thirdPlaceLabel,
    onPreviousButtonClick,
    onNextButtonClick,
  } = props;

  return (
    <div className="flex flex-col">
      <div className="flex">
        {isPreviousButtonVisible && (
          <div className="w-[60px] flex flex-col gap-1">
            <MatchGroupPrevious onButtonClick={onPreviousButtonClick} />
            {!isFinal && <MatchGroupPrevious onButtonClick={onPreviousButtonClick} />}
          </div>
        )}
        <div className="relative flex-1 flex flex-col gap-1">
          <BracketCard {...firstMatch} />
          {!isFinal && <BracketCard {...secondMatch} />}
        </div>
        {isFinal ? (
          <div className="relative w-[60px] flex items-center">
            <div className="absolute left-[-20px] w-[80px] overflow-hidden pointer-events-none">
              <GlowingTrophy />
            </div>
          </div>
        ) : (
          isNextButtonVisible && (
            <div className="relative w-[60px] flex items-center justify-center">
              <div className="flex-1 h-[calc(50%+0.25rem)] border-t border-b border-r rounded-r-[13px] border-pmw-fc-brand-light dark:border-pmw-fc-brand-dark" />
              <div className="flex-1 h-px bg-pmw-fc-brand-light dark:bg-pmw-fc-brand-dark" />
              <RoundButton
                aria-label="Next round"
                className="absolute"
                icon={
                  <ChevronRightIcon
                    aria-hidden="true"
                    className="text-pmw-icon-fill-secondary-light dark:text-pmw-icon-fill-secondary-dark"
                  />
                }
                onClick={onNextButtonClick}
              />
            </div>
          )
        )}
      </div>
      {thirdPlaceMatch && (
        <div className="mx-[60px] mt-[12px] flex flex-col gap-[12px]">
          <span className="font-robotoMedium text-[12px] leading-[16px] text-pmw-label-secondary-light dark:text-pmw-label-secondary-dark text-center">
            {thirdPlaceLabel}
          </span>
          <BracketCard {...thirdPlaceMatch} />
        </div>
      )}
    </div>
  );
}
